import { createAsyncThunk } from '@reduxjs/toolkit';
import projectApi from '~/apis/project';
import { GET_PROJECTS } from '~/utils/constants/actionType';
import { IParamsGetProjects, IResponseGetProject } from '~/utils/interface/project';

export const handleGetProjects = createAsyncThunk<IResponseGetProject, IParamsGetProjects>(
  GET_PROJECTS,
  async (params: IParamsGetProjects = {}, { rejectWithValue }) => {
    try {
      const res = await projectApi.getLists(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

